import React, { ReactNode, useState } from "react";
import Cookies from "universal-cookie";
import { Member } from "../../lib/types/member";
import { GlobalContext } from "../hooks/useGlobals";
import { getAccessToken, syncAuthHeader } from "../services/auth";

const ContextProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const cookeis = new Cookies();
  if (!cookeis.get("accessToken") && !getAccessToken()) {
    localStorage.removeItem("memberData");
  }
  syncAuthHeader();

  const [authMember, setAuthMember] = useState<Member | null>(
    localStorage.getItem("memberData")
      ? JSON.parse(localStorage.getItem("memberData") as string)
      : null
  );
  const [orderBuilder, setOrderBuilder] = useState<Date>(new Date());
  console.log("=== verify ===");
  return (
    <GlobalContext.Provider
      value={{ authMember, setAuthMember, orderBuilder, setOrderBuilder }}
    >
      {children}
    </GlobalContext.Provider>
  );
};

export default ContextProvider;
